import { post } from './common'

type ApiBaseResult<T> = ApiTypes.ApiBaseResult<T>

export namespace user {
  export function login(data: PostData.Login) {
    return post<ApiBaseResult<ServerData.LoginData>>('/login', {}, { ...data })
  }
}
